<template>
  <window-container class="product-class-window">
    <div class="title">
      Edit Class
    </div>
    <table>
      <tr>
        <td>In Category</td>
        <td>
          <el-select v-model="currentCategoryId" @change="changeCategory">
            <el-option v-for="item in categoryList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </td>
        <td></td>
      </tr>
      <tr>
        <td>Class</td>
        <td>
          <el-table
            ref="classTable"
            :data="classList"
            highlight-current-row
            @current-change="handleCurrentChange"
            :show-header="false"
            height="300"
            style="width:500px;">
            <el-table-column
              prop="name"
              label="Class Name"
              width="300">
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <el-button icon="el-icon-arrow-up" :disabled="scope.row.id === classList[0].id" @click="up(scope.row)"></el-button>
                <el-button icon="el-icon-arrow-down" :disabled="scope.row.id === classList[classList.length -1].id" @click="down(scope.row)"></el-button>
                <el-button icon="el-icon-delete" @click="del(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </td>
      </tr>
      <tr>
        <td>Change Name</td>
        <td>
          <el-input v-model="updateName" style="width:250px;"></el-input>
          <el-button @click="update">Update Class Name</el-button>
        </td>
      </tr>
      <tr>
        <td>New Class</td>
        <td>
          <el-input v-model="insertName" style="width:250px;"></el-input>
          <el-button @click="insert">Add New Class</el-button>
        </td>
      </tr>
    </table>
  </window-container>
</template>

<script>
export default {
  data () {
    return {
      categoryList: [],
      classList: [],
      currentCategoryId: parseInt(this.$route.params.id),
      updateId: 0,
      updateName: '',
      insertName: ''
    }
  },
  mounted () {
    this.fetchCategoryList()
    this.fetchClassList()
  },
  methods: {
    fetchCategoryList () {
      this.$http.get('/dbapi/category_list').then(data => {
        this.categoryList = data.list
      })
    },
    fetchClassList () {
      this.$http.get('/dbapi/class_list?category_id=' + this.currentCategoryId).then(data => {
        this.classList = data.list
      })
    },
    changeCategory (val) {
      if (!!val) {
        this.currentCategoryId = parseInt(val)
        this.fetchClassList()
      }
    },
    handleCurrentChange (row) {
      if (!!row) {
        this.updateId = row.id
        this.updateName = row.name
      }
    },
    insert () {
      if (!this.insertName) {
        return
      }
      this.$http.post('/dbapi/class_insert', {
        category_id: this.currentCategoryId,
        name: this.insertName,
        order_no: this.classList[this.classList.length - 1].order_no + 1
      }).then(data => {
        this.insertName = ''
        this.fetchClassList()
      })
    },
    update () {
      if (!this.updateName) {
        return
      }
      this.$http.post('/dbapi/class_update', {
        id: this.updateId,
        name: this.updateName
      }).then(data => {
        this.updateName = ''
        this.fetchClassList()
      })
    },
    up (row) {
      this.$http.post('/dbapi/class_order_up', {
        category_id: row.category_id,
        order_no: row.order_no
      }).then(data => {
        this.fetchClassList()
      })
    },
    down (row) {
      this.$http.post('/dbapi/class_order_down', {
        category_id: row.category_id,
        order_no: row.order_no
      }).then(data => {
        this.fetchClassList()
      })
    },
    del (row) {
      this.$confirm(`You sure you want to delete it？[${row.name}]`, 'Confirm', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/class_del', {
          id: row.id
        }).then(data => {
          this.fetchClassList()
        })
      })
    },
    close () {
      this.$close()
    }
  }
}
</script>

<style>
.product-class-window {
  background-color: #fff;
}
.product-class-window .title {
  background-color: #b0c8f5;
  font-size: 16px;
  font-weight: bold;
  padding: 4px 10px;
}
.product-class-window table {
  border-spacing: 0;
}
.product-class-window table td {
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}
.product-class-window .el-table td {
  padding: 4px 0;
}
</style>